import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CpeService} from '../cpe.service';
import {SharedService} from '../../shared/shared.service';
import {Alerts} from '../../shared/enums/alerts';
import {CpeBase} from "../cpeBase";

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CpeTo } from 'src/app/shared/models/cpeTo';
import {Observable, of} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';

@Component({
    selector: 'app-create-cpe',
    templateUrl: './create-cpe.component.html',
    styleUrls: ['./create-cpe.component.scss']
})
export class CreateCpeComponent extends CpeBase implements OnInit {
    
    cpe: CpeTo;

    constructor(@Inject(MAT_DIALOG_DATA) public selectedOrg, 
                private CpeService: CpeService, 
                public dialogRef: MatDialogRef<CreateCpeComponent>,
                public sharedService: SharedService) {
        super();
    }

    ngOnInit() {
        this.header = "Create CPE System";
        this.initializaData();
    }

    initializaData() {
        this.cpeName.setValue('');
    }

    isValidData() {
        this.markFormControlsAsTouched();
        return this.cpeName.valid;
    }

    // Search is a "contains" match, so fetch every match and compare names exactly (case-insensitive)
    isDuplicateCpe(name: string): Observable<boolean> {
        const pageSize = 50;
        return this.CpeService.getCpePage(name, 'cpeName', 'asc', 0, pageSize).pipe(
            switchMap(page => page.totalElements > pageSize
                ? this.CpeService.getCpePage(name, 'cpeName', 'asc', 0, page.totalElements)
                : of(page)),
            map(page => page.content.some(cpe => cpe.cpeName.toLowerCase() === name.toLowerCase())));
    }

    checkDuplicateCpe(onUnique: () => void) {
        const name = this.cpeName.value;
        this.isDuplicateCpe(name).subscribe({
            next: isDuplicate => {
                if (isDuplicate) {
                    this.loading = false;
                    this.sharedService.showAlert(Alerts.ERROR, 'CPE with name "' + name + '" already exists.');
                } else {
                    onUnique();
                }
            },
            error: error => {
                console.error("Error checking duplicate CPE names", error);
                this.loading = false;
                this.sharedService.handleErrors(error,
                    [],
                    "Unable to validate CPE name uniqueness");
            },
            complete: () => {}
        });
    }

    createCpe() {
        if (!this.isValidData()) {
            return;
        }
            this.loading = true;
            const payload = new CpeTo();
            payload.cpeName = this.cpeName.value;
            // check for duplicate CPE name before creating
            this.checkDuplicateCpe(() => this.CpeService.createCpe(payload).subscribe({
                next: data => {
                    this.loading = false;
                    this.sharedService.showAlert(Alerts.SUCCESS, 'CPE System created successfully');
                    this.dialogRef.close(true);
                },
                error: error => {
                    console.error("Error creating CPE System", error);
                    this.loading = false;
                    this.sharedService.handleErrors(error,
                        [{ 
                            "condition": (error.status === 400 && Object.keys(error.error).length > 0),
                           "msg": error.error
                        }],
                        "Unable to create CPE System");
                },
                complete: () => {}
            }));
    }

    resetCpe() {
        if (this.fieldcheck === true) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Your changes will be lost!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, Reset',
                cancelButtonText: 'No, Cancel',
            }).then((result) => {
                if (result.value) {
                    this.cpeName.setValue('');
                    this.initializaData();
                }
            });
        } else {
            this.cpeName.setValue('');
            this.initializaData();
        }
    }

    close() {
        if (this.fieldcheck === true) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Your changes will not be saved !',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, Close',
                cancelButtonText: 'No, Cancel',
            }).then((result) => {
                if (result.value) {
                    this.dialogRef.close(false);
                }
            });
        } else {
            this.dialogRef.close(false);
        }
    }

}
